import { Modal } from "antd";
import { Button } from "components/Button/Button";
import { StoreProviderForm } from "components/Form/StoreProviderForm";
import { IconCollection } from "components/Icon/IconCollection";
import {
    getUncommittedStatusBadgeIcon,
    UncommittedStatusBadgeImage,
} from "components/IconWithStatusBadge/IconWithStatusBadge";
import {
    Action,
    ActionData,
    ActionSignature,
} from "containers/Resources/components/CommonActions/Action";
import {
    BulkResetToStatusInGitAction,
    getInitialModal,
    getRecordOrContainerIsGitEnabled,
} from "containers/Resources/screens/ResourcesSingle/components/GitAction/GitAction";
import { BulkCommitForm } from "containers/Resources/screens/ResourcesSingle/components/GitAction/commitActions/formComponents/BulkCommitForm";
import {
    bulkCommit,
    getRecordLocation,
    getUncommittedChangesCount,
    isContainerType,
    isGitActionButtonDisabled,
} from "containers/Resources/screens/ResourcesSingle/components/GitAction/commitActions/utils";
import { Form as FinalForm } from "react-final-form";

export const BulkCommitAction: Action = async (data, dispatch, history) => {
    const uncommittedData = data?.uncommittedData;
    const uncommittedRecordList = Object.values(uncommittedData ?? {});

    return new Promise((resolve, reject) => {
        const location = isContainerType(data.resourceType)
            ? data.resourceType
            : getRecordLocation(data.resourceData);
        const locationName = isContainerType(data.resourceType)
            ? data.resourceData.name
            : data.resourceData[`${location}_id_${location}`].name;
        const modal = getInitialModal(`Bulk commit in ${location} "${locationName}"`);

        const closeModal = () => modal.destroy();
        const closeAll = () => Modal.destroyAll();

        const form = (
            <StoreProviderForm>
                <FinalForm
                    onSubmit={(formData: any) =>
                        bulkCommit({
                            formData,
                            actionData: data,
                            closeModal: closeAll,
                            uncommittedData,
                        })
                    }
                    initialValues={{
                        commit_message: "",
                        records: [],
                    }}
                >
                    {(props: any) => (
                        <BulkCommitForm
                            uncommittedRecordList={uncommittedRecordList}
                            closeModal={closeModal}
                            {...props}
                        />
                    )}
                </FinalForm>
            </StoreProviderForm>
        );

        modal.update((previousConfig) => ({
            ...previousConfig,
            content: form,
        }));
    });
};
export const bulkCommitActionKey = "bulk_commit";
export const bulkCommitActionSignature: ActionSignature = {
    key: bulkCommitActionKey,
    action: BulkCommitAction,
    label: (data: ActionData) => "Bulk commit",
    icon: (data: ActionData) => {
        const uncommittedChangesCount = getUncommittedChangesCount(data?.uncommittedData);
        return getUncommittedStatusBadgeIcon(uncommittedChangesCount);
    },
    inlineActionIcon: () => IconCollection.uploadMultiple,
    image: (data: ActionData) => {
        const uncommittedChangesCount = getUncommittedChangesCount(data?.uncommittedData);
        return uncommittedChangesCount ? (
            <UncommittedStatusBadgeImage uncommittedChangesCount={uncommittedChangesCount} />
        ) : null;
    },
    disableWhen: (data: ActionData) =>
        isGitActionButtonDisabled(data) || data?.isGitLocked || false,
    omitWhen: (data: ActionData) =>
        !getRecordOrContainerIsGitEnabled(data?.resourceType, data?.resourceData),
    hasAfterAction: true,
    isDropdown: () => true,
    dropdownContent: ({ actionData, dispatch, history }) => {
        return (
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                }}
            >
                <Button
                    key={"bulkResetToStatusInGit"}
                    label={"Bulk reset to status in git"}
                    icon={IconCollection.undo}
                    variation="clear"
                    className="wide"
                    onClick={() => BulkResetToStatusInGitAction(actionData, dispatch, history)}
                />
            </div>
        );
    },
};
